// src/pages/Pipeline/MeasurementPhotos.jsx
import React, { useState } from "react";
import { Box, Paper, Typography, Button } from "@mui/material";
import { useParams, useNavigate } from "react-router-dom";
import api from "../../utils/api";

export default function MeasurementPhotos() {
  const { id } = useParams();
  const navigate = useNavigate();

  const [files, setFiles] = useState([]);

  async function upload() {
    const form = new FormData();
    form.append("lead_id", id);
    for (let f of files) form.append("photos", f);

    try {
      await api.post("/leads/measurement/photos", form, {
        headers: { "Content-Type": "multipart/form-data" }
      });

      alert("Photos uploaded");
      navigate(`/leads/${id}`);
    } catch (err) {
      console.error(err);
      alert("Upload failed");
    }
  }

  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h5">Upload Measurement Photos</Typography>
      <Paper sx={{ p: 3, mt: 2 }}>
        <input multiple type="file" accept="image/*" onChange={(e) => setFiles(e.target.files)} />
        <br /><br />
        <Button variant="contained" onClick={upload}>Upload</Button>
        <Button sx={{ ml: 2 }} variant="outlined" onClick={() => navigate(-1)}>Back</Button>
      </Paper>
    </Box>
  );
}
